// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import axios from 'axios';
import { toast } from 'react-toastify';

function getEnvironmentVariable(value, defaultValue) {
    return value && value.length > 0 && value !== "" ? value : defaultValue;
}

let apiUrl, uiUrl, switchTeam = ()=>{};

// Local development
if (window.location.host.includes("localhost")) {
    apiUrl = getEnvironmentVariable(process.env.REACT_APP_API_URL, "http://localhost:8080");
    uiUrl = getEnvironmentVariable(process.env.REACT_APP_UI_URL, "http://localhost:3000");
}
// Production
else {
    apiUrl = getEnvironmentVariable(process.env.REACT_APP_API_URL, window.location.protocol + "//"  + window.location.host.replace("my.","api."));
    uiUrl = getEnvironmentVariable(process.env.REACT_APP_UI_URL, window.location.protocol + "//"  + window.location.host);
}

axios.defaults.withCredentials = true;

// Error handling and authorization check
const handleError = (res, skipAuth, ignoreError=false) => {

    let data;

    if (!res || !res.data)
        return ignoreError ? null : toast.error("No response for server.");

    data = res.data;

    // Authorization error - redirect to login page
    if (data.authError) {
        if (skipAuth)
            return;
        window.location = '/login?redirect=' + window.location.pathname;
        return;
    }

    // Switch team request?
    if (data.action === "switch-team" && data.team) {
        switchTeam(data.team, window.location.href);
        return;
    }

    // General error?
    if (!data.success && data.error && !ignoreError)
        toast.error(data.error);
    
    return data;

};


export default {

    // Get request
    get: async (endpoint, data={}, skipAuth=false, config={}, ignoreError=false) => {
        let res;
        try {
            res = await axios.get(apiUrl + endpoint, data, config);
        } catch (err) {
            if (axios.isCancel(err)) {
                return {
                    success: false,
                    cancelled: true, 
                    error: "Cancelled request"
                }
            } else {
                throw(err);
            }
        }
        return handleError(res, skipAuth, ignoreError);
    },

    // Post request
    post: async (endpoint, data={}, skipAuth=true, config={}) => {
        let res;
        try {
            res = await axios(apiUrl + endpoint, {
                method: "post",
                data: data,
                withCredentials: true,
                ...config
            });
            // res = await axios.post(apiUrl + endpoint, data, config);
        } catch (err) {
            if (axios.isCancel(err)) {
                return {
                    success: false,
                    cancelled: true, 
                    error: "Cancelled request"
                }
            } else {
                throw(err);
            }
        }
        
        return handleError(res, skipAuth);
    },

    // Download
    download: async (endpoint, skipAuth=false, config={}, external=false) => {
        let res;
        try {
            res = await axios({
                method: 'get',
                url: (external ? "" : apiUrl) + endpoint,
                responseType: 'blob'
            }, config);
        } catch (err) {
            if (axios.isCancel(err)) {
            } else {
                throw(err);
            }
        }
        return handleError(res, skipAuth);
    },

    // Open file in window
    open: (endpoint, target="_blank") => {
        window.open(apiUrl + endpoint, target);
    },

    publicUrl: uiUrl,
    apiUrl: apiUrl,
    setTeamSwitcher: (fn) => { switchTeam = fn }

}